import { useContext, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Typography } from '@mui/material';
import colors from '../../essentials/colors';
import styled from 'styled-components';
import AuthContext from '../../context/auth/authContext';
import ClientrdContext from '../../context/clientrd/clientrdContext';
import { useNavigate } from 'react-router-dom';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import IconButton from '@mui/material/IconButton';
import Spinner from '../layout/Spinner';

const TableSummary = styled(TableContainer)`
    background: ${colors.lightblue};
`;
const PaymentTableCell = styled(TableCell)`
    && {
        font-weight: 900;
        background: rgba(149, 213, 84);
        font-size: 18px;
    }
`;
const PaymentBodyTableCell = styled(TableCell)`
    && {
        font-weight: 300;
        // background: rgba(149, 213, 84, 0.5);
        font-size: 18px;
    }
`;

const NetIncome = styled(Paper)`
    && {
        border: 4px solid ${colors.purple};
        background-color: ${colors.purple};
        color: white;
        border-radius: 10px;
        box-shadow: 4px 5px 5px ${colors.grey};
    }
`;
const AmountPaid = styled(Paper)`
    && {
        border: 4px solid ${colors.primary};
        color: white;
        background-color: ${colors.primary};
        border-radius: 10px;
        box-shadow: 4px 5px 5px ${colors.grey};
    }
`;

const AmountPending = styled(Paper)`
    && {
        border: 4px solid ${colors.orange};
        color: ${colors.orange};
        border-radius: 10px;
        // box-shadow: 4px 5px 5px ${colors.grey};
    }
`;
const TotalClients = styled(Paper)`
    && {
        background: rgba(182, 88, 255, 0.4);
        background-color: ${colors.lightblue};
        // border: 4px solid ${colors.lightblue};
        color: white;
        border-radius: 10px;
        box-shadow: 4px 5px 5px ${colors.grey};
    }
`;

const PaymentSummary = () => {
    const authContext = useContext(AuthContext);
    const { isAuthenticated, logout, user, loadUser } = authContext;

    const clientrdContext = useContext(ClientrdContext);
    const { clientrds, getClientrds, updateClientrd, deleteClientrd } =
        clientrdContext;
    const [netincome, setNetincome] = useState(0);
    const [paymentcomplete, setPayment] = useState(0);
    const [amountdue, setAmountDue] = useState(0);
    const [paidclients, setPaidClients] = useState(0);
    const [deletee, setDeletee] = useState(false);

    let navigate = useNavigate();
    let noc = 0;
    let value = 0;
    noc = clientrds?.length;
    useEffect(() => {
        !isAuthenticated ? navigate('/login') : null;

        getClientrds();
        setTimeout(() => {
            getClientrds();
        }, 2000);
        setDashboardValues();
    }, [netincome, clientrds, deletee, clientrds?.length]);

    const setPaymentStatus = (id, status) => {
        updateClientrd({
            _id: id,
            paymentstatus: status == 'Paid' ? 'Unpaid' : 'Paid'
        });
    };
    const deletePayment = async (id) => {
        await deleteClientrd(id);
        setDeletee(false);
    };

    const setDashboardValues = () => {
        let paymentcmp = 0;
        let countp = 0;
        noc > 0
            ? clientrds?.map((amt) => {
                  value = value + amt?.amount;
                  amt?.paymentstatus == 'Paid'
                      ? ((paymentcmp = paymentcmp + amt?.amount), (countp += 1))
                      : null;
                  setNetincome(value);
                  setPayment(paymentcmp);
                  setPaidClients(countp);
                  setAmountDue(netincome - paymentcmp);
              })
            : (setNetincome(0),
              setPayment(0),
              setPaidClients(0),
              setAmountDue(0));
        // setNetincome(value);
    };

    return (
        <>
            <div style={{ marginBottom: 2 }}>
                Welcome! <b>{user && user.name}</b>
            </div>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={0}>
                        <Typography variant="h4">Overview</Typography>
                    </Grid>
                    <Grid item style={{ textAlign: 'center' }} xs={12} md={4}>
                        <NetIncome elevation={3} style={{ padding: 15 }}>
                            <p>
                                <b>Net Income</b>
                            </p>
                            <h3>
                                <b>₹ {netincome}/-</b>
                            </h3>
                            <p>{noc} clients</p>
                        </NetIncome>
                    </Grid>

                    <Grid item style={{ textAlign: 'center' }} xs={12} md={4}>
                        <AmountPaid elevation={3} style={{ padding: 15 }}>
                            <p>
                                <b>Payment Complete</b>
                            </p>
                            <h3>
                                <b>₹ {paymentcomplete} /-</b>
                            </h3>
                            <p>{paidclients} clients</p>
                        </AmountPaid>
                    </Grid>
                    <Grid item style={{ textAlign: 'center' }} xs={12} md={4}>
                        <AmountPending elevation={2} style={{ padding: 15 }}>
                            <p>
                                <b>Amount Due</b>
                            </p>
                            <h3>
                                <b>₹ {amountdue}/-</b>
                            </h3>
                            <p>
                                {noc - paidclients === NaN
                                    ? 0
                                    : noc - paidclients}{' '}
                                clients
                            </p>
                        </AmountPending>
                    </Grid>

                    {/* <Grid item style={{ textAlign: 'center' }} xs={12} md={3}>
                        <TotalClients
                            elevation={2}
                            style={{ padding: 23.5, alignItems: 'center' }}
                        >
                            <p>
                                <b>Total No. of Clients on the Platform</b>
                            </p>
                            <h2>
                                <b>{noc}</b>
                            </h2>
                        </TotalClients>
                    </Grid> */}
                </Grid>
            </Box>

            <br></br>
            <Typography variant="h4">Earning History</Typography>
            <br></br>
            {clientrds?.length == 0 || clientrds?.length == undefined ? (
                <>
                    <Typography variant="h5" style={{ textAlign: 'center' }}>
                        <br></br> No client record present.
                    </Typography>
                    <br></br>
                    <p style={{ textAlign: 'center' }}>
                        <button
                            onClick={() => navigate('/clientform')}
                            style={{
                                height: '60px',
                                width: '160px',
                                fontWeight: '300',
                                backgroundColor: `${colors.primary}`,
                                fontSize: '16px',
                                borderColor: 'transparent',
                                borderRadius: '10px'
                            }}
                        >
                            Add A Client
                        </button>
                    </p>
                </>
            ) : (
                <TableSummary component={Paper}>
                    <Table sx={{ minWidth: 200 }} size="small">
                        <TableHead>
                            <TableRow>
                                <PaymentTableCell>
                                    Date of Creation
                                </PaymentTableCell>
                                <PaymentTableCell align="left">
                                    Client Name
                                </PaymentTableCell>
                                <PaymentTableCell align="left">
                                    Amount
                                </PaymentTableCell>
                                <PaymentTableCell align="right">
                                    Payment Status
                                </PaymentTableCell>
                                <PaymentTableCell align="right">
                                    Set Payment Status
                                </PaymentTableCell>
                                {/* <PaymentTableCell
                                    align="left"
                                    style={{ backgroundColor: 'white' }}
                                ></PaymentTableCell>
                                <PaymentTableCell
                                    align="left"
                                    style={{ backgroundColor: 'white' }}
                                ></PaymentTableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {clientrds?.map((row) => (
                                <TableRow
                                    key={row.createdAt}
                                    sx={{
                                        '&:last-child td, &:last-child th': {
                                            border: 0
                                        }
                                    }}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <PaymentBodyTableCell
                                        scope="row"
                                        onClick={() => {
                                            navigate('/agentdescription', {
                                                state: row
                                            });
                                        }}
                                    >
                                        <p style={{ color: 'white' }}>
                                            {row.createdAt.slice(0, 10)}
                                        </p>
                                    </PaymentBodyTableCell>
                                    <PaymentBodyTableCell
                                        align="center"
                                        onClick={() => {
                                            navigate('/agentdescription', {
                                                state: row
                                            });
                                        }}
                                    >
                                        <p style={{ color: 'white' }}>
                                            {row.name}
                                        </p>
                                    </PaymentBodyTableCell>
                                    <PaymentBodyTableCell
                                        align="center"
                                        onClick={() => {
                                            navigate('/agentdescription', {
                                                state: row
                                            });
                                        }}
                                    >
                                        <p style={{ color: 'white' }}>
                                            ₹{row.amount}/-
                                        </p>
                                    </PaymentBodyTableCell>
                                    <PaymentBodyTableCell
                                        align="center"
                                        onClick={() => {
                                            navigate('/agentdescription', {
                                                state: row
                                            });
                                        }}
                                    >
                                        <p style={{ color: 'white' }}>
                                            {row.paymentstatus}
                                        </p>
                                    </PaymentBodyTableCell>
                                    <PaymentBodyTableCell align="center">
                                        <button
                                            onClick={() =>
                                                setPaymentStatus(
                                                    row._id,
                                                    row.paymentstatus
                                                )
                                            }
                                            style={{
                                                height: '40px',
                                                width: '60px',
                                                fontWeight: '300',
                                                background:
                                                    'rgb(250, 235, 215)',
                                                fontSize: '16px',
                                                borderColor: 'transparent',
                                                borderRadius: '10px'
                                            }}
                                        >
                                            {row.paymentstatus == 'Paid'
                                                ? 'Unpaid'
                                                : 'Paid'}
                                        </button>
                                    </PaymentBodyTableCell>
                                    <PaymentBodyTableCell
                                        align="left"
                                        style={{
                                            backgroundColor: 'white',
                                            borderColor: 'transparent'
                                        }}
                                    >
                                        <IconButton
                                            size="large"
                                            aria-label="Clientform"
                                            style={{ color: 'black' }}
                                            onClick={() => {
                                                navigate('/clientform', {
                                                    state: row
                                                });
                                            }}
                                        >
                                            <EditSharpIcon />
                                            <Typography
                                                variant="body2"
                                                align="center"
                                            ></Typography>
                                        </IconButton>
                                    </PaymentBodyTableCell>
                                    <PaymentBodyTableCell
                                        align="left"
                                        style={{
                                            backgroundColor: 'white',

                                            borderColor: 'transparent'
                                        }}
                                    >
                                        <IconButton
                                            size="large"
                                            aria-label="Clientform"
                                            style={{ color: 'darkred' }}
                                            onClick={(async) => {
                                                setDeletee(true);

                                                deletePayment(row?._id);
                                            }}
                                        >
                                            {deletee == true ? (
                                                <Spinner
                                                    style={{
                                                        height: '20px',
                                                        width: '60px'
                                                    }}
                                                />
                                            ) : (
                                                <DeleteSharpIcon />
                                            )}

                                            <Typography
                                                variant="body2"
                                                align="center"
                                            ></Typography>
                                        </IconButton>
                                    </PaymentBodyTableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableSummary>
            )}
        </>
    );
};
export default PaymentSummary;
